import { LANGUAGELIST_SEARCH, LANGUAGELIST_PAGE } from '../actions/languagelistactions';

const state = { search:'', page:0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [LANGUAGELIST_SEARCH]: ({ commit }, search) => {
        commit(LANGUAGELIST_SEARCH, search);
    },
    [LANGUAGELIST_PAGE]: ({ commit }, page) => {
        commit(LANGUAGELIST_PAGE, page);
    }
};

const mutations = {
    [LANGUAGELIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [LANGUAGELIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};